import React, { useState, useEffect, useRef } from 'react';
import styles from '../../pages/CustomJob/PostJob.module.scss';
import saveIcon from "../../assets/images/saveIcon.png";
import addIcon from "../../assets/images/add.svg";
import removeIcon from "../../assets/images/reduce-icon.svg";
import downArrow from "../../assets/images/downArrow.png";
import indianFlag from "../../assets/images/indianFlag.PNG";
import whatsappIcon from "../../assets/images/whatsapp.png";

// Range Slider Component
const RangeSlider = ({ min, max, from, to, step, onChange }) => {
  const [minVal, setMinVal] = useState(from);
  const [maxVal, setMaxVal] = useState(to);

  useEffect(() => {
    setMinVal(from);
    setMaxVal(to);
  }, [from, to]);

  const handleMinChange = (e) => {
    const value = Math.min(parseInt(e.target.value), maxVal - step);
    setMinVal(value);
    onChange({ from: value, to: maxVal });
  };

  const handleMaxChange = (e) => {
    const value = Math.max(parseInt(e.target.value), minVal + step);
    setMaxVal(value);
    onChange({ from: minVal, to: value });
  };

  const minPercent = ((minVal - min) / (max - min)) * 100;
  const maxPercent = ((maxVal - min) / (max - min)) * 100;

  return (
    <div className={styles['range-slider-container']}>
      <div className={styles['slider-track']}></div>
      <div 
        className={styles['slider-range']} 
        style={{ left: `${minPercent}%`, right: `${100 - maxPercent}%` }}
      ></div>
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        step={step}
        onChange={handleMinChange}
        className={`${styles.slider} ${styles['slider-min']}`}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        step={step}
        onChange={handleMaxChange}
        className={`${styles.slider} ${styles['slider-max']}`}
      />
    </div>
  );
};

const PostJob = ({ empId, adminId, onClose,onSuccess}) => {
  // API Base URLs
  const API_BASE_URL = 'https://prod.java.taizo.in/webEmployer';
  const ADMIN_API_BASE_URL = 'https://prod.java.taizo.in/admin';

  // State variables
  const [employerId, setEmployerId] = useState(empId || '');
  const [categoryOption, setCategoryOption] = useState('');
  const [jobRoleCategory, setJobRoleCategory] = useState('');
  const [jobRole, setJobRole] = useState('');
  const [noOfOpenings, setNoOfOpenings] = useState('');
  const [male, setMale] = useState(0);
  const [female, setFemale] = useState(0);
  const [jobDescription, setJobDescription] = useState('');
  const [minSalary, setMinSalary] = useState('');
  const [maxSalary, setMaxSalary] = useState('');
  const [minExp, setMinExp] = useState('');
  const [keySkills, setKeySkills] = useState([]);
  const [educationQualification, setEducationQualification] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const [shiftType, setShiftType] = useState('');
  const [otType, setOtType] = useState('');
  const [workHours, setWorkHours] = useState('');
  const [locationUrl, setLocationUrl] = useState('');
  const [contactPersonName, setContactPersonName] = useState('');
  const [contactNum, setContactNum] = useState('');
  const [alternateNum, setAlternateNum] = useState('');
  const [whatAppNumber, setWhatAppNumber] = useState('');
  const [emailID, setEmailID] = useState('');
  const [whatsappNoti, setWhatsappNoti] = useState(true);
  
  // Add these state variables
  const [filteredKeySkills, setFilteredKeySkills] = useState([]);
  const [keySkillSearchTerm, setKeySkillSearchTerm] = useState('');
  
  // UI State
  const [showAlternateNum, setShowAlternateNum] = useState(false);
  const [showAddDetails, setShowAddDetails] = useState(true);
  const [showKeySkillsPopup, setShowKeySkillsPopup] = useState(false);
  const [showEduQualityPopup, setShowEduQualityPopup] = useState(false);
  const [showJobRoleModal, setShowJobRoleModal] = useState(false);
  const [selectedJobRole, setSelectedJobRole] = useState('');
  const [showSalaryModal, setShowSalaryModal] = useState(false);
  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const [showWhatsAppAlert, setShowWhatsAppAlert] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otpFor, setOtpFor] = useState('');
  
  // Data state
  const [industries, setIndustries] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [keySkillsList, setKeySkillsList] = useState([]);
  const [benefitsList, setBenefitsList] = useState([]);
  const [filteredJobRoles, setFilteredJobRoles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [salaryRange, setSalaryRange] = useState({ from: 14000, to: 20000 });
  const [fileName, setFileName] = useState('No file chosen');
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  
  // Error state
  const [errors, setErrors] = useState({});
  
  // OTP state
  const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showOtpError, setShowOtpError] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const otpInputsRef = useRef([]);
  
  // Refs
  const fileInputRef = useRef(null);
  const jobRoleSearchRef = useRef(null);
  const keyskillsSearchRef = useRef(null);

  

  // Fetch initial data
  useEffect(() => {
    fetchIndustries();
    fetchKeySkills();
    fetchBenefits();
    
    const urlParams = new URLSearchParams(window.location.search);
    const employerIdParam = urlParams.get('employer_id');
    if (employerIdParam) {
      setEmployerId(employerIdParam);
      fetchEmployerDetails(employerIdParam);
    }
    
    const savedJobId = urlParams.get('savedJob_id');
    if (savedJobId) {
      fetchSavedJobDetails(savedJobId);
    }
    
    const repostId = urlParams.get('repostJob_id');
    if (repostId) {
      fetchJobDetails(repostId);
    }
  }, []);

  // OTP Timer
  useEffect(() => {
    let interval;
    if (otpTimer > 0) {
      interval = setInterval(() => {
        setOtpTimer(prev => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpTimer]);

  // API Functions
  const fetchIndustries = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/jobIndustries`);
      const data = await response.json();
      if (data?.data) {
        setIndustries(data.data);
      }
    } catch (error) {
      console.error('Error fetching industries:', error);
    }
  };

  const fetchJobRoles = async (industryId) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/fullTimeJobRoles?industry_id=${industryId}`);
      const data = await response.json();
      if (data?.data) {
        setJobRoles(data.data);
        setFilteredJobRoles(data.data);
        if (jobRoleSearchRef.current) {
          jobRoleSearchRef.current.value = '';
        }
      }
    } catch (error) {
      console.error('Error fetching job roles:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchKeySkills = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/keySkills`);
      const data = await response.json();
      if (data?.data) {
        setKeySkillsList(data.data);
      }
    } catch (error) {
      console.error('Error fetching key skills:', error);
    }
  };

  const fetchBenefits = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/benefits`);
      const data = await response.json();
      if (data?.data) {
        setBenefitsList(data.data);
      }
    } catch (error) {
      console.error('Error fetching benefits:', error);
    }
  };

  const fetchEmployerDetails = async (empId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/empDetails?emp_id=${empId}`);
      const data = await response.json();
      if (data?.employer) {
        setContactPersonName(data.employer.contactPersonName || '');
        setContactNum(data.employer.mobileNumber || '');
        setWhatAppNumber(data.employer.whatsappNumber || '');
      }
    } catch (error) {
      console.error('Error fetching employer details:', error);
    }
  };

  const fetchSavedJobDetails = async (jobId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/job/${jobId}`);
      const data = await response.json();
      if (data?.jobDetails) {
        populateJobForm(data.jobDetails);
      }
    } catch (error) {
      console.error('Error fetching saved job:', error);
    }
  };

  const fetchJobDetails = async (jobId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/job/${jobId}`);
      const data = await response.json();
      if (data?.jobDetails) {
        populateJobForm(data.jobDetails);
      }
    } catch (error) {
      console.error('Error fetching job details:', error);
    }
  };

  const populateJobForm = (jobData) => {
    setJobRoleCategory(jobData.jobCategory || '');
    setJobRole(jobData.industry || '');
    setNoOfOpenings(jobData.noOfOpenings?.toString() || '');
    setMale(jobData.male || 0);
    setFemale(jobData.female || 0);
    setMinSalary(jobData.salary?.toString() || '');
    setMaxSalary(jobData.maxSalary?.toString() || '');
    
    if (jobData.jobExp === '0' && jobData.jobMaxExp === '0') {
      setMinExp('Freshers');
    } else if (jobData.jobExp === '0' && jobData.jobMaxExp === '1') {
      setMinExp('0 - 1');
    } else {
      setMinExp(jobData.jobExp || '');
    }
    
    setKeySkills(jobData.keyskills?.split(', ').filter(s => s) || []);
    setEducationQualification(jobData.qualification?.split(', ').filter(q => q) || []);
    setBenefits(jobData.benefits?.split(', ').filter(b => b) || []);
    setShiftType(jobData.shiftType || '');
    setOtType(jobData.ot || '');
    setWorkHours(jobData.workHours || '');
    setLocationUrl(jobData.companyLocationUrl || '');
    setContactPersonName(jobData.contactPersonName || '');
    setContactNum(jobData.mobileNumber || '');
    setAlternateNum(jobData.alternateMobileNumber || '');
    setWhatAppNumber(jobData.whatsappNumber || '');
    setEmailID(jobData.emailId || '');
    setJobDescription(jobData.jobDescription || '');
    setCategoryOption(jobData.collarType || '');
    setWhatsappNoti(jobData.whatsappNoti !== false);
  };

  // OTP Functions
  const sendOtp = async (number, type) => {
    if (!number || number.length !== 10) {
      alert('Please enter a valid 10-digit number');
      return;
    }

    setOtpLoading(true);
    setOtpFor(type);
    
    try {
      const response = await fetch(`${API_BASE_URL}/sendOtp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobileNumber: number })
      });
      
      const data = await response.json();
      if (data.status) {
        setShowOtpPopup(true);
        setOtpValues(['', '', '', '', '', '']);
        setOtpTimer(60);
        setShowOtpError(false);
      } else {
        alert('Failed to send OTP. Please try again.');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert('Error sending OTP. Please try again.');
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    const otp = otpValues.join('');
    
    if (otp.length !== 6) {
      setShowOtpError(true);
      return;
    }

    setOtpLoading(true);
    const number = otpFor === 'alternate' ? alternateNum : contactNum;

    try {
      const response = await fetch(`${API_BASE_URL}/verifyOtp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobileNumber: number, otp })
      });
      
      const data = await response.json();
      if (data.status) {
        setOtpVerified(true);
        setTimeout(() => {
          setShowOtpPopup(false);
          setOtpValues(['', '', '', '', '', '']);
          setOtpVerified(false);
        }, 2000);
      } else {
        setShowOtpError(true);
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setShowOtpError(true);
    } finally {
      setOtpLoading(false);
    }
  };

  const resendOtp = async (e) => {
    e.preventDefault();
    const number = otpFor === 'alternate' ? alternateNum : contactNum;
    await sendOtp(number, otpFor);
  };

  // Handlers
  const handleMaleIncrease = () => {
    setMale(prev => prev + 1);
    removeError('gender');
  };
  
  const handleMaleDecrease = () => {
    setMale(prev => Math.max(0, prev - 1));
    removeError('gender');
  };
  
  const handleFemaleIncrease = () => {
    setFemale(prev => prev + 1);
    removeError('gender');
  };
  
  const handleFemaleDecrease = () => {
    setFemale(prev => Math.max(0, prev - 1));
    removeError('gender');
  };

  const handleKeySkillToggle = (skill) => {
    setKeySkills(prev => {
      if (prev.includes(skill)) {
        return prev.filter(s => s !== skill);
      } else if (prev.length < 5) {
        return [...prev, skill];
      }
      return prev;
    });
    removeError('keySkills');
  };

  const handleEducationToggle = (qual) => {
    setEducationQualification(prev => {
      if (prev.includes(qual)) {
        return prev.filter(q => q !== qual);
      } else {
        return [...prev, qual];
      }
    });
    removeError('education');
  };

  const handleBenefitToggle = (benefit) => {
    setBenefits(prev => {
      if (prev.includes(benefit)) {
        return prev.filter(b => b !== benefit);
      } else if (prev.length < 10) {
        return [...prev, benefit];
      }
      return prev;
    });
    
    // Update textarea
    const textarea = document.getElementById('benefits_text_area');
    if (textarea) {
      textarea.value = benefits.join(', ');
    }
    removeError('benefits');
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleJobRoleSearch = (e) => {
    const search = e.target.value.toLowerCase();
    
    if (search.trim() === '') {
      setFilteredJobRoles(jobRoles);
    } else {
      const filtered = jobRoles.filter(role => 
        role.jobRoles?.toLowerCase().includes(search)
      );
      setFilteredJobRoles(filtered);
    }
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otpValues];
      newOtp[index] = value;
      setOtpValues(newOtp);
      setShowOtpError(false);
      
      if (value && index < 5) {
        otpInputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      otpInputsRef.current[index - 1]?.focus();
    }
  };

  // Salary handlers
  const handleSalaryFromChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    const numVal = val ? parseInt(val) : 0;
    setSalaryRange({ ...salaryRange, from: numVal });
  };

  const handleSalaryToChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    const numVal = val ? parseInt(val) : 0;
    setSalaryRange({ ...salaryRange, to: numVal });
  };

  const handleSalaryRangeChange = (range) => {
    setSalaryRange(range);
  };

  const handleSalaryConfirm = () => {
    if (salaryRange.from >= 10000 && salaryRange.to >= 10000) {
      setMinSalary(salaryRange.from.toString());
      setMaxSalary(salaryRange.to.toString());
      setShowSalaryModal(false);
      removeError('salary');
    } else {
      document.getElementById('salary_error_txt')?.classList.remove(styles['d-none']);
    }
  };

  // Key Skills Search Handler
  const handleKeySkillSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    
    if (searchTerm.trim() === '') {
      setFilteredKeySkills([]);
    } else {
      const filtered = keySkillsList.filter(skill => 
        skill.skill.toLowerCase().includes(searchTerm)
      );
      setFilteredKeySkills(filtered);
    }
  };

//  Add error class to form group
const addErrorClass = (fieldId) => {
  // Find the element based on fieldId
  let element = null;
  
  switch(fieldId) {
    case 'gender':
      element = document.getElementById('gender_male');
      break;
    case 'salary':
      element = document.getElementById('minSalary');
      break;
    case 'benefits':
      element = document.getElementById('benefits_text_area');
      break;
    case 'keySkills':
      element = document.getElementById('keySkill_input');
      break;
    case 'education':
      element = document.getElementById('edu_quality_error');
      break;
    default:
      element = document.getElementById(fieldId);
  }
  
  // If element exists, find and add error class to form group
  if (element) {
    const formGroup = element.closest(`.${styles['form-group']}`);
    if (formGroup) {
      formGroup.classList.add(styles.error);
    }
  } else {
    // Fallback: try to find by name or other selectors
    const fallbackElement = document.querySelector(`[id="${fieldId}"], [name="${fieldId}"]`);
    if (fallbackElement) {
      const formGroup = fallbackElement.closest(`.${styles['form-group']}`);
      if (formGroup) {
        formGroup.classList.add(styles.error);
      }
    }
  }
};

// Improved removeError function
const removeError = (fieldId) => {
  // Remove from errors state
  setErrors(prev => {
    const newErrors = { ...prev };
    delete newErrors[fieldId];
    return newErrors;
  });
  
  // Small delay to ensure DOM is updated
  setTimeout(() => {
    // Find the element based on fieldId
    let element = null;
    
    switch(fieldId) {
      case 'gender':
        element = document.getElementById('gender_male');
        break;
      case 'salary':
        element = document.getElementById('minSalary');
        break;
      case 'benefits':
        element = document.getElementById('benefits_text_area');
        break;
      case 'keySkills':
        element = document.getElementById('keySkill_input');
        break;
      case 'education':
        element = document.getElementById('edu_quality_error');
        break;
      default:
        element = document.getElementById(fieldId);
    }
    
    // Try multiple approaches to find and remove error class
    if (element) {
      const formGroup = element.closest(`.${styles['form-group']}`);
      if (formGroup) {
        formGroup.classList.remove(styles.error);
      }
    } else {
      // Fallback: try to find by common patterns
      const possibleElements = [
        document.querySelector(`[id="${fieldId}"]`),
        document.querySelector(`[name="${fieldId}"]`),
        document.querySelector(`.${fieldId}`),
        document.getElementById(fieldId)
      ].filter(el => el);
      
      possibleElements.forEach(el => {
        const formGroup = el.closest(`.${styles['form-group']}`);
        if (formGroup) {
          formGroup.classList.remove(styles.error);
        }
      });
    }
  }, 0);
};

// Update the validation function to better handle errors
const validateForm = () => {
  const newErrors = {};
  
  // Clear all existing error classes first
  document.querySelectorAll(`.${styles['form-group']}.${styles.error}`).forEach(el => {
    el.classList.remove(styles.error);
  });
  
  if (!employerId) {
    newErrors.employerId = 'Please enter Employer id';
  }
  if (!categoryOption) {
    newErrors.categoryOption = 'Please select job category';
  }
  if (!jobRoleCategory) {
    newErrors.jobRoleCategory = 'Please select job role';
  }
  if (!noOfOpenings) {
    newErrors.noOfOpenings = 'Please enter no of openings';
  } else if (parseInt(noOfOpenings) <= 0) {
    newErrors.noOfOpenings = 'No of openings must be greater than 0';
  }
  
  if (male === 0 && female === 0) {
    newErrors.gender = 'Please enter at least one candidate';
  } else if (parseInt(noOfOpenings || 0) > 0 && male + female !== parseInt(noOfOpenings)) {
    newErrors.gender = `Total candidates (${male + female}) should equal no of openings (${noOfOpenings})`;
  }
  
  if (!minSalary || !maxSalary) {
    newErrors.salary = 'Please select salary range';
  }
  if (!minExp) {
    newErrors.minExp = 'Please select experience';
  }
  if (keySkills.length === 0) {
    newErrors.keySkills = 'Please select key skills';
  }
  if (educationQualification.length === 0) {
    newErrors.education = 'Please select education';
  }
  if (benefits.length === 0) {
    newErrors.benefits = 'Please select benefits';
  }
  if (!shiftType) {
    newErrors.shiftType = 'Please select shift type';
  }
  if (!otType) {
    newErrors.otType = 'Please select overtime';
  }
  if (!workHours) {
    newErrors.workHours = 'Please select work hours';
  }
  if (!locationUrl) {
    newErrors.locationUrl = 'Please enter location URL';
  }
  if (!contactPersonName) {
    newErrors.contactPersonName = 'Please enter contact person';
  }
  if (!contactNum) {
    newErrors.contactNum = 'Please enter contact number';
  } else if (contactNum.length !== 10) {
    newErrors.contactNum = 'Please enter valid 10-digit number';
  }
  if (!whatAppNumber) {
    newErrors.whatAppNumber = 'Please enter WhatsApp number';
  } else if (whatAppNumber.length !== 10) {
    newErrors.whatAppNumber = 'Please enter valid 10-digit WhatsApp number';
  }
  if (!emailID) {
    newErrors.emailID = 'Please enter email';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailID)) {
    newErrors.emailID = 'Please enter valid email';
  }
  
  setErrors(newErrors);
  
  // Add error classes after setting errors
  setTimeout(() => {
    Object.keys(newErrors).forEach(fieldId => {
      addErrorClass(fieldId);
    });
  }, 0);
  
  return Object.keys(newErrors).length === 0;
};

// Fix the onChange handlers to properly remove errors
const handleInputChange = (e, setter) => {
  const { id, value } = e.target;
  setter(value);
  removeError(id);
};

const handleSelectChange = (e, setter, fieldId) => {
  const value = e.target.value;
  setter(value);
  removeError(fieldId);
};

const handleRadioChange = (e, setter, fieldId) => {
  setter(e.target.value);
  removeError(fieldId);
};

  // Submit function
  const handleSubmit = async () => {
    if (!validateForm()) {
      const firstError = Object.keys(errors)[0];
      document.getElementById(firstError)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    
    setLoading(true);
    
    const gender = male === 0 ? 'female' : female === 0 ? 'male' : 'both';
    const jobExp = minExp === 'Freshers' ? '0' : minExp === '0 - 1' ? '0' : minExp;
    const jobMaxExp = minExp === 'Freshers' ? '0' : minExp === '0 - 1' ? '1' : minExp;
    
    const jobData = {
      employerId: parseInt(employerId),
      industry: jobRole || jobRoleCategory,
      jobCategory: jobRoleCategory,
      salary: minSalary,
      maxSalary: maxSalary,
      jobExp, 
      jobMaxExp,
      qualification: educationQualification.join(', '),
      contactPersonName,
      companyLocationUrl: locationUrl,
      mobileNumber: contactNum,
      alternateMobileNumber: alternateNum || null,
      shiftType, 
      workHours, 
      male, 
      female,
      ot: otType,
      benefits: benefits.join(', '),
      whatsappNoti,
      keyskills: keySkills.join(', '),
      gender,
      whatsappNumber: whatAppNumber,
      noOfOpenings: parseInt(noOfOpenings),
      emailId: emailID,
      jobDescription,
      collarType: categoryOption,
    };

    try {
      const response = await fetch(`${ADMIN_API_BASE_URL}/newPostJob?admin_id=${adminId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jobData)
      });
      
      const data = await response.json();
      
      if (data?.data?.id) {
        if (selectedFile) {
          await uploadJobDescription(data.data.id);
        }
        
        showSuccessPopup('Job Published Successfully');
          if (onSuccess) {
          onSuccess();
        }
        
        setTimeout(() => {
          if (onClose) onClose();
          else window.location.reload();
        }, 2000);
      } else {
        alert(data.message || 'Failed to publish job');
      }
    } catch (error) {
      console.error('Error publishing job:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const uploadJobDescription = async (jobId) => {
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      await fetch(`${ADMIN_API_BASE_URL}/jobDescriptionUpload?id=${jobId}`, {
        method: 'PUT',
        body: formData
      });
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const saveAsDraft = async () => {
    setLoading(true);
    
    const gender = male === 0 ? 'female' : female === 0 ? 'male' : 'both';
    const jobExp = minExp === 'Freshers' ? '0' : minExp === '0 - 1' ? '0' : minExp;
    const jobMaxExp = minExp === 'Freshers' ? '0' : minExp === '0 - 1' ? '1' : minExp;
    
    const jobData = {
      employerId: parseInt(employerId),
      industry: jobRole || jobRoleCategory,
      jobCategory: jobRoleCategory,
      salary: minSalary,
      maxSalary: maxSalary,
      jobExp, 
      jobMaxExp,
      qualification: educationQualification.join(', '),
      contactPersonName,
      companyLocationUrl: locationUrl,
      mobileNumber: contactNum,
      alternateMobileNumber: alternateNum || null,
      shiftType, 
      workHours, 
      male, 
      female,
      ot: otType,
      benefits: benefits.join(', '),
      whatsappNoti,
      keyskills: keySkills.join(', '),
      gender,
      whatsappNumber: whatAppNumber,
      noOfOpenings: parseInt(noOfOpenings),
      emailId: emailID,
      jobDescription,
      collarType: categoryOption,
    };

    try {
      const response = await fetch(`${ADMIN_API_BASE_URL}/saveDraftJob?admin_id=${adminId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(jobData)
      });
      
      const data = await response.json();
      
      if (data.status) {
        showSuccessPopup('Job Saved as Draft');
        setShowSavePopup(false);
      } else {
        alert(data.message || 'Failed to save draft');
      }
    } catch (error) {
      console.error('Error saving draft:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const showSuccessPopup = (message) => {
    const popup = document.createElement('div');
    popup.className = styles['success-popup'];
    popup.innerHTML = `
      <div class="${styles['success-content']}">
        <svg viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="46.5" fill="none" stroke="rgba(76, 175, 80, 0.5)" stroke-width="5"/>
          <path d="M67,93 A46.5,46.5 0 1,0 7,32 L43,67 L88,19" fill="none" stroke="#4CAF50" stroke-width="5" stroke-linecap="round"/>
        </svg>
        <p>${message}</p>
      </div>
    `;
    document.body.appendChild(popup);
    setTimeout(() => popup.remove(), 2000);
  };

  return (
    <div className={styles['post-job-content']}>
      <div className={`container-fluid-sm ${styles['post_a_job_form']}`}>
        <div className={styles.postJobContainer}>
          {/* Header */}
          <div className={styles.pstJobHead}>
            {/* <p className="text-sm-center">Job Post Form</p> */}
            <div className={`d-grid ${styles['justify-content-end']} mb-4`} style={{ marginTop: '-45px' }}>
              {/* <div>
                <span 
                  className="save_job_btn" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => setShowSavePopup(true)}
                >
                  <img src={saveIcon} width="15px" alt="save" />
                  <span style={{ fontSize: '15px' }}> &nbsp; Save</span>
                </span>
                <div className="d-inline-block">
                  <span className={`${styles.closeBtn} mx-3 mx-sm-5`} onClick={onClose}></span>
                </div>
              </div> */}
            </div>
          </div>
          
          {/* Form Content */}
          <div className={`py-3 px-md-3 px-lg-4 px-sm-2`}>
            <span className={styles['text-green']} style={{ fontWeight: 600 }}>Job Details</span>
            
            {/* Employer ID and Category */}
            <div className={`row mb-3`}>
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.employerId ? styles.error : ''}`}>
                  <label htmlFor="employerId">Employer Id</label>
                  <input
                    className={styles['form-control']}
                    type="number"
                    id="employerId"
                    value={employerId}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                      setEmployerId(val);
                      removeError('employerId');
                    }}
                    placeholder="Enter employer id"
                    disabled={!!empId}
                  />
                  {errors.employerId && <div className={styles.validMsg}>{errors.employerId}</div>}
                </div>
              </div>
              
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.categoryOption ? styles.error : ''}`}>
                  <label htmlFor="categoryOption">Which Job Do You Want You Post?</label>
                  <div className={styles['field-wrapper']}>
                    <select
                      className={`${styles['form-control']} ${styles['field-input']}`}
                      id="categoryOption"
                      value={categoryOption}
                      onChange={(e) => handleSelectChange(e, setCategoryOption, 'categoryOption')}
                    >
                      <option value="">-Select--</option>
                      <option value="Operator Category">Operator Category</option>
                      <option value="MidSenior Category">MidSenior Category</option>
                    </select>
                    <div className={styles['field-arrow']}>
                      <img src={downArrow} alt="dropdown" />
                    </div>
                  </div>
                  {errors.categoryOption && <div className={styles.validMsg}>{errors.categoryOption}</div>}
                </div>
              </div>
            </div>
            
            {/* Job Role and No of Openings */}
          <div className={`row mb-3`}>
              <div className={`col-sm-6`}>
    <div className={`${styles['form-group']} ${errors.jobRoleCategory ? styles.error : ''}`}>
      <label htmlFor="jobRoleCategory">Job Role</label>
      <div className={styles['field-wrapper']} onClick={() => setShowJobRoleModal(true)}>
        <input
          type="text"
          id="jobRoleCategory"
          className={`${styles['form-control']} ${styles['field-input']}`}
          placeholder="--Select--"
          value={selectedJobRole || jobRoleCategory}
          readOnly
        />
        <div className={styles['field-arrow']}>
          <img src={downArrow} alt="dropdown" />
        </div>
      </div>
      {errors.jobRoleCategory && <div className={`${styles.validMsg} mt-2`}>{errors.jobRoleCategory}</div>}
    </div>
  </div>
  
              <div className={`col-sm-6`}>
    <div className={`${styles['form-group']} ${errors.noOfOpenings ? styles.error : ''}`}>
      <label htmlFor="noOfOpenings">No of Openings</label>
      <input
        type="text"
        id="noOfOpenings"
        className={styles['form-control']}
        placeholder="No Of Openings"
        value={noOfOpenings}
        onChange={(e) => {
          const val = e.target.value.replace(/\D/g, '').slice(0, 3);
          setNoOfOpenings(val);
          removeError('noOfOpenings');
        }}
      />
      {errors.noOfOpenings && <div className={`${styles.validMsg} ${styles.noOfOpenigsError} mt-3`}>{errors.noOfOpenings}</div>}
                </div>
    </div>
  </div>
  
            {/* Gender Counters */}
            <div className={`row`}>
              <div className={`col-sm-6`}>
    <div className={`${styles['form-group']} ${errors.gender ? styles.error : ''}`}>
                  <div className={`d-flex flex-row flex-wrap`}>
                    <div className={`${styles['no-of-openings-amount-div']} me-3 mb-2`}>
                      <div className={styles['no-of-openings-div']}>
                        <div className={styles['no-of-openings-div1']}>
                          <label className={styles['no-of-openings-label']}>No. of Male(s)</label>
                          <div className={`${styles['no-of-openings-add-and-redu']} border`}>
                            <div 
                              className={`${styles['no-of-openings-reduce-btn']} px-2`} 
                onClick={handleMaleDecrease}
              >
                              <img className={styles['reduce-icon']} alt="reduce" src={removeIcon} />
                            </div>
                            <div className={`${styles['no-of-openings-value-filed']} border ms-1`}>
                              <div className={styles['no-of-openings']} id="gender_male">{male}</div>
                            </div>
                            <div 
                              className={`${styles['no-of-openings-add-btn']} px-2`} 
                onClick={handleMaleIncrease}
              >
                              <img className={styles['add-icon']} alt="add" src={addIcon} />
                            </div>
                          </div>
            </div>
          </div>
        </div>
        
                    <div className={`${styles['no-of-openings-amount-div']} mb-2`}>
                      <div className={styles['no-of-openings-div']}>
                        <div className={styles['no-of-openings-div1']}>
                          <label className={styles['no-of-openings-label']}>No. of Female(s)</label>
                          <div className={`${styles['no-of-openings-add-and-redu']} border`}>
                            <div 
                              className={`${styles['no-of-openings-reduce-btn']} px-2`} 
                onClick={handleFemaleDecrease}
              >
                              <img className={styles['reduce-icon']} alt="reduce" src={removeIcon} />
                            </div>
                            <div className={`${styles['no-of-openings-value-filed']} border ms-1`}>
                              <div className={styles['no-of-openings']} id="gender_female">{female}</div>
                            </div>
                            <div 
                              className={`${styles['no-of-openings-add-btn']} px-2`} 
                onClick={handleFemaleIncrease}
              >
                              <img className={styles['add-icon']} alt="add" src={addIcon} />
                            </div>
                          </div>
            </div>
          </div>
        </div>
      </div>
      {errors.gender && <div className={`${styles.validMsg} ${styles.maleFemaleErr} mt-2`}>{errors.gender}</div>}
    </div>
  </div>
              
              <div className={`col-sm-6`}>
                <div className={`mt-2 ${styles['form-group']} ms-3`}>
                  <label className={styles['no-of-openings-label']}>Job Description</label>
                  <textarea
                    className={styles['form-control']}
                    placeholder="Job Description"
                    id="JobDescription"
                    value={jobDescription}
                    onChange={(e) => setJobDescription(e.target.value)}
                    rows="3"
                  />
                </div>
              </div>
</div>
            
            {/* Salary and File Upload */}
            <div className={`row`}>
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.salary ? styles.error : ''}`}>
                  <label>Salary (per month)</label>
                  <div className={`row`}>
                    <div className={`col-4`}>
                      <input type="text" disabled className={styles['form-control']} placeholder="₹ INR" />
                    </div>
                    <div className={`col-4`}>
                      <div onClick={() => setShowSalaryModal(true)} style={{ cursor: 'pointer' }}>
                        <input
                          type="text"
                          id="minSalary"
                          className={styles['form-control']}
                          placeholder="Min"
                          value={minSalary}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className={`col-4`}>
                      <div onClick={() => setShowSalaryModal(true)} style={{ cursor: 'pointer' }}>
                        <input
                          type="text"
                          id="maxSalary"
                          className={styles['form-control']}
                          placeholder="Max"
                          value={maxSalary}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  {errors.salary && <div className={styles.validMsg}>{errors.salary}</div>}
                </div>
              </div>

              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} mx-3 mb-1`}>
                  <label htmlFor="formFile">Job Description (Upload File)</label>
                  <div className={styles['file-upload-container']}>
                    <input
                      type="file"
                      id="formFile"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                    <button 
                      type="button"
                      className={styles['file-choose-btn']}
                      onClick={() => fileInputRef.current?.click()}
                    >
                      Choose file
                    </button>
                    <span className={styles['file-name']}>{fileName}</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Benefits and Experience */}
            <div className={`row mb-3`}>
              <div className={`col-sm-6 ${styles['adddetails-margin-top']}`}>
                <div className={`${styles['form-group']} ${errors.benefits ? styles.error : ''}`}>
                  <label>Benefits</label>
                  <div 
                    className={styles['benefits-field-wrapper']} 
                    onClick={() => setShowBenefitsModal(true)}
                  >
                    <textarea
                      className={`${styles['form-control']} ${styles['benefits-textarea']}`}
                      id="benefits_text_area"
                      placeholder="Ex: PF, ESI"
                      value={benefits.join(', ')}
                      readOnly
                    />
                    <div className={styles['field-arrow']}>
                      <img src={downArrow} alt="dropdown" />
                    </div>
                  </div>
                  {errors.benefits && <div className={`${styles.validMsg} mt-1`}>{errors.benefits}</div>}
                </div>
              </div>
              
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} mt-1 ${errors.minExp ? styles.error : ''}`}>
                  <label>Minimum Experience</label>
                  <div className={styles['experience-buttons']}>
                    <button
                      type="button"
                      className={`${styles['experience-option']} ${minExp === '0 - 1' ? styles.active : ''}`}
                      onClick={() => {
                        setMinExp('0 - 1');
                        removeError('minExp');
                      }}
                    >
                      0 - 1
                    </button>
                    <button
                      type="button"
                      className={`${styles['experience-option']} ${minExp === 'Freshers' ? styles.active : ''}`}
                      onClick={() => {
                        setMinExp('Freshers');
                        removeError('minExp');
                      }}
                    >
                      Freshers
                    </button>
                  </div>
                  <div className={styles['field-wrapper']}>
                    <select
                      className={`${styles['form-control']} ${styles['field-input']}`}
                      id="minExp"
                      value={minExp}
                      onChange={(e) => handleSelectChange(e, setMinExp, 'minExp')}
                    >
                      <option value="">Ex: 2 - 4 Years</option>
                      <option value="Freshers">Fresher</option>
                      <option value="0 - 1">0 - 1</option>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                        <option key={num} value={num}>{num} Year{num > 1 ? 's' : ''}</option>
                      ))}
                    </select>
                    <div className={styles['field-arrow']}>
                      {/* <img src={downArrow} alt="dropdown" /> */}
                    </div>
                  </div>
                  {errors.minExp && <div className={`${styles.validMsg} mt-2`}>{errors.minExp}</div>}
                </div>
              </div>
            </div>
            
            {/* Key Skills and Education */}
            <div className={`row`}>
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.keySkills ? styles.error : ''}`}>
                  <label>Key Skills</label>
                  <div className={styles['field-wrapper']} onClick={() => setShowKeySkillsPopup(true)}>
                    <div className={`${styles['form-control']} ${styles['field-input']}`} id="keySkill_input">
                      {keySkills.length > 0 ? keySkills.join(', ') : <span className={styles.placeholder}>Select key skills</span>}
                    </div>
                    <div className={styles['field-arrow']}>
                      <img src={downArrow} alt="dropdown" />
                    </div>
                  </div>
                  {errors.keySkills && <div className={styles.validMsg}>{errors.keySkills}</div>}
                </div>
              </div>
              
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.education ? styles.error : ''}`}>
                  <label>Educational Qualification</label>
                  <div className={styles['field-wrapper']} onClick={() => setShowEduQualityPopup(true)}>
                    <div className={`${styles['form-control']} ${styles['field-input']}`} id="edu_quality_input">
                      {educationQualification.length > 0 ? educationQualification.join(', ') : <span className={styles.placeholder}>Select education qualification</span>}
                    </div>
                    <div className={styles['field-arrow']}>
                      <img src={downArrow} alt="dropdown" />
                    </div>
                  </div>
                  {errors.education && <div className={`${styles.validMsg} mt-2`} id="edu_quality_error">{errors.education}</div>}
                </div>
              </div>
            </div>
          </div>
          
          {/* Additional Details Section - Always Visible */}
          <div className={styles.addDetailsContainer}>
            <div className={`py-3 px-md-3 px-lg-4 px-sm-2`}>
              <span className={styles['text-green']} style={{ fontWeight: 600 }}>Additional Details</span>
              
              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} ${errors.shiftType ? styles.error : ''}`}>
                    <label>Shift</label>
                    <div className={styles['radio-group']}>
                      <label className={`${styles['radio-label']} ${shiftType === 'General' ? styles.active : ''}`}>
                        <input
                          type="radio"
                          value="General"
                          name="shiftType"
                          checked={shiftType === 'General'}
                          onChange={(e) => handleRadioChange(e, setShiftType, 'shiftType')}
                        />
                        <span>General</span>
                      </label>
                      <label className={`${styles['radio-label']} ${shiftType === 'Rotational' ? styles.active : ''}`}>
                        <input
                          type="radio"
                          value="Rotational"
                          name="shiftType"
                          checked={shiftType === 'Rotational'}
                          onChange={(e) => handleRadioChange(e, setShiftType, 'shiftType')}
                        />
                        <span>Rotational</span>
                      </label>
                    </div>
                    {errors.shiftType && <div className={styles.validMsg}>{errors.shiftType}</div>}
                  </div>
                </div>
                
                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} ${errors.otType ? styles.error : ''}`}>
                    <label>Over Time</label>
                    <div className={styles['radio-group']}>
                      <label className={`${styles['radio-label']} ${otType === 'Yes' ? styles.active : ''}`}>
                        <input
                          type="radio"
                          value="Yes"
                          name="otType"
                          checked={otType === 'Yes'}
                          onChange={(e) => handleRadioChange(e, setOtType, 'otType')}
                        />
                        <span>Yes</span>
                      </label>
                      <label className={`${styles['radio-label']} ${otType === 'No' ? styles.active : ''}`}>
                        <input
                          type="radio"
                          value="No"
                          name="otType"
                          checked={otType === 'No'}
                          onChange={(e) => handleRadioChange(e, setOtType, 'otType')}
                        />
                        <span>No</span>
                      </label>
                    </div>
                    {errors.otType && <div className={styles.validMsg}>{errors.otType}</div>}
                  </div>
                </div>
              </div>
              
              <div className={`row`}>
                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} ${errors.workHours ? styles.error : ''}`}>
                    <label>Work Hours</label>
                    <div className={styles['field-wrapper']}>
                      <select
                        className={`${styles['form-control']} ${styles['field-input']}`}
                        id="workHours"
                        value={workHours}
                        onChange={(e) => handleSelectChange(e, setWorkHours, 'workHours')}
                      >
                        <option value="">Ex: 8 hours</option>
                        <option value="8 hours">8 hours</option>
                        <option value="9 hours">9 hours</option>
                        <option value="10 hours">10 hours</option>
                        <option value="11 hours">11 hours</option>
                        <option value="12 hours">12 hours</option>
                      </select>
                      <div className={styles['field-arrow']}>
                        {/* <img src={downArrow} alt="dropdown" /> */}
                      </div>
                    </div>
                    {errors.workHours && <div className={styles.validMsg}>{errors.workHours}</div>}
                  </div>
                </div>
                
                <div className={`col-sm-6`}>
                  <div className={`${styles['form-group']} ${errors.locationUrl ? styles.error : ''}`}>
                    <label>Location url</label>
                    <textarea
                      className={styles['form-control']}
                      rows="1"
                      id="locationUrl"
                      placeholder="Location Url"
                      value={locationUrl}
                      onChange={(e) => handleInputChange(e, setLocationUrl)}
                    />
                    {errors.locationUrl && <div className={styles.validMsg}>{errors.locationUrl}</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Details Section */}
          <div className={`py-3 px-md-3 px-lg-4 px-sm-2`}>
            <span className={styles['text-green']} style={{ fontWeight: 600 }}>Contact Details</span>
            
            <div className={`row`}>
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.contactPersonName ? styles.error : ''}`}>
                  <label>Contact Person Name</label>
                  <input
                    type="text"
                    id="contactPersonName"
                    className={styles['form-control']}
                    placeholder="Contact Person Name"
                    value={contactPersonName}
                    onChange={(e) => handleInputChange(e, setContactPersonName)}
                  />
                  {errors.contactPersonName && <div className={styles.validMsg}>{errors.contactPersonName}</div>}
                </div>
              </div>
              
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.contactNum ? styles.error : ''}`}>
                  <label>Contact Number</label>
                  <div className={styles['phone-input-container']}>
                    <div className={styles['country-code']}>
                      <img src={indianFlag} alt="IN" width="15" />
                      <span>+91</span>
                    </div>
                    <input
                      type="number"
                      id="contactNum"
                      className={`${styles['form-control']} ${styles['phone-input']}`}
                      placeholder="Contact Number"
                      value={contactNum}
                      onChange={(e) => {
                        const val = e.target.value.slice(0, 10);
                        setContactNum(val);
                        removeError('contactNum');
                      }}
                    />
                  </div>
                  <button 
                    type="button"
                    className={styles['add-alternate-btn']}
                    onClick={() => setShowAlternateNum(true)}
                  >
                    <span className={styles['plus-icon']}>+</span>
                    Add alternate Mobile Number
                  </button>
                  {errors.contactNum && <div className={styles.validMsg}>{errors.contactNum}</div>}
                </div>
              </div>
            </div>
            
            {showAlternateNum && (
              <div className={`row ${styles['alternate-number-row']}`}>
                <div className={`col-sm-6`}>
                  <div className={styles['alternate-number-container']}>
                    <div className={`${styles['form-group']} ${errors.alternateNum ? styles.error : ''}`}>
                      <label>Alternate Number</label>
                      <button 
                        type="button"
                        className={styles['cancel-btn']}
                        onClick={() => setShowAlternateNum(false)}
                      >
                        Cancel
                      </button>
                      <div className={styles['phone-input-container']}>
                        <div className={styles['country-code']}>
                          <img src={indianFlag} alt="IN" width="15" />
                          <span>+91</span>
                        </div>
                        <input
                          type="number"
                          id="alternateNum"
                          className={`${styles['form-control']} ${styles['phone-input']}`}
                          placeholder="Alternate Number"
                          value={alternateNum}
                          onChange={(e) => {
                            const val = e.target.value.slice(0, 10);
                            setAlternateNum(val);
                            removeError('alternateNum');
                          }}
                        />
                      </div>
                      <div className={`d-grid ${styles['justify-content-end']}`} style={{ marginTop: '5px' }}>
                        {/* <button
                          type="button"
                          onClick={() => sendOtp(alternateNum, 'alternate')}
                          className={styles['send-otp-btn']}
                          disabled={otpLoading}
                        >
                          {otpLoading ? 'Sending...' : 'Send OTP'}
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            <div className={`row`}>
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.whatAppNumber ? styles.error : ''}`}>
                  <label htmlFor="whatAppNumber">WhatsApp number</label>
                  <input
                    className={styles['form-control']}
                    type="number"
                    id="whatAppNumber"
                    placeholder="Enter your WhatsApp number"
                    value={whatAppNumber}
                    onChange={(e) => {
                      const val = e.target.value.slice(0, 10);
                      setWhatAppNumber(val);
                      removeError('whatAppNumber');
                    }}
                    style={{
                      backgroundImage: `url(${whatsappIcon})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '20px',
                      backgroundPosition: '97% center',
                      paddingRight: '35px'
                    }}
                  />
                  {errors.whatAppNumber && <div className={styles.validMsg}>{errors.whatAppNumber}</div>}
                </div>
              </div>
              
              <div className={`col-sm-6`}>
                <div className={`${styles['form-group']} ${errors.emailID ? styles.error : ''}`}>
                  <label htmlFor="emailID">Contact Email ID</label>
                  <input
                    className={styles['form-control']}
                    type="email"
                    id="emailID"
                    placeholder="Enter the email id"
                    value={emailID}
                    onChange={(e) => handleInputChange(e, setEmailID)}
                  />
                  {errors.emailID && <div className={styles.validMsg}>{errors.emailID}</div>}
                </div>
              </div>
            </div>
          </div>
          
          {/* Submit Button */}
          <div className={styles['submit-section']}>
            <button
              onClick={handleSubmit}
              className={styles['publish-btn']}
              disabled={loading}
            >
              {loading ? 'Publishing...' : 'Publish'}
            </button>
          </div>
          
          {/* <p className={styles['help-text']}>
            If you have any issues, please <a href="https://wame.pro/taizo.in" target="_blank" rel="noopener noreferrer">Click Here</a>
          </p> */}
        </div>
      </div>
      
      {/* JOB ROLE MODAL */}
      {showJobRoleModal && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['job-role-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Select Industry?</h4>
              <button className={styles['close-btn']} onClick={() => setShowJobRoleModal(false)}>×</button>
            </div>
            
            <div className={styles['industries-list']}>
              {industries.map(industry => (
                <button
                  key={industry.id}
                  type="button"
                  className={`${styles['btn-job-industry']} ${selectedIndustry === industry.id ? styles.active : ''}`}
                  onClick={() => {
                    if (selectedIndustry === industry.id) return;
                    setSelectedJobRole('');
                    setJobRoleCategory('');
                    setJobRole('');
                    setFilteredJobRoles([]);
                    if (jobRoleSearchRef.current) {
                      jobRoleSearchRef.current.value = '';
                    }
                    setSelectedIndustry(industry.id);
                    fetchJobRoles(industry.id);
                    removeError('jobRoleCategory');
                  }}
                >
                  {industry.industry}
                </button>
              ))}
            </div>

            <div className={styles.divider}></div>
            
            <div className={styles['modal-header']} style={{ marginTop: '10px' }}>
              <h4>Select Job Role?</h4>
            </div>
            
            {selectedIndustry && (
              <div className={styles['search-container']}>
                <input
                  ref={jobRoleSearchRef}
                  type="text"
                  className={styles['job_role_auto-search']}
                  placeholder="Search job roles"
                  onChange={handleJobRoleSearch}
                />
                <span className={styles['search-icon']}>🔍</span>
              </div>
            )}
            
            {!selectedIndustry && (
              <div className={styles['no-industry-message']}>
                Please select an industry first
              </div>
            )}
            
            {selectedIndustry && (
              <div className={styles['job-roles-container']}>
                {loading ? (
                  <div className={styles.loading}>Loading...</div>
                ) : (
                  (filteredJobRoles.length > 0 ? filteredJobRoles : jobRoles).map(role => (
                    <button
                      key={role.id}
                      type="button"
                      className={`${styles['job-role-item']} ${selectedJobRole === role.jobRoles ? styles.selected : ''}`}
                      onClick={() => {
                        setSelectedJobRole(role.jobRoles);
                        setJobRoleCategory(role.jobRoles);
                        setJobRole(role.jobRoles);
                        setShowJobRoleModal(false);
                        removeError('jobRoleCategory');
                      }}
                    >
                      {role.jobRoles}
                      {selectedJobRole === role.jobRoles && (
                        <span className={styles['check-mark']}>✓</span>
                      )}
                    </button>
                  ))
                )}
              </div>
            )}
            
            <div className={`${styles['invalid-confirm']} d-none`}>Please fill out this field</div>
          </div>
        </div>
      )}
      
      {/* SALARY MODAL */}
      {showSalaryModal && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['salary-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Salary Range</h4>
              <button className={styles['close-btn']} onClick={() => setShowSalaryModal(false)}>×</button>
            </div>
            
            <div className={styles['salary-inputs']}>
              <div className={styles['input-group']}>
                <label>Min</label>
                <input
                  type="text"
                  value={salaryRange.from}
                  onChange={handleSalaryFromChange}
                  placeholder="Min"
                />
              </div>
              <div className={styles['input-group']}>
                <label>Max</label>
                <input
                  type="text"
                  value={salaryRange.to}
                  onChange={handleSalaryToChange}
                  placeholder="Max"
                />
              </div>
            </div>
            
            <div className={styles['salary-value-display']}>
              ₹{salaryRange.from.toLocaleString()} – ₹{salaryRange.to.toLocaleString()}
            </div>
            
            <RangeSlider
              min={10000}
              max={200000}
              from={salaryRange.from}
              to={salaryRange.to}
              step={500}
              onChange={handleSalaryRangeChange}
            />
            
            <div className={styles['salary-scale']}>
              <span>10k</span>
              <span>50k</span>
              <span>100k</span>
              <span>150k</span>
              <span>200k</span>
            </div>
            
            <div id="salary_error_txt" className={`${styles['error-message']} d-none`}>
              Candidates are not responding to jobs with salaries less than INR 10000
            </div>
            
            <div className={styles['modal-footer']}>
              <button className={styles['cancel-btn']} onClick={() => setShowSalaryModal(false)}>Cancel</button>
              <button className={styles['confirm-btn']} onClick={handleSalaryConfirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* BENEFITS MODAL */}
      {showBenefitsModal && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['benefits-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>
                Select benefits 
                {benefits.length >= 10 && <span className={styles['max-warning']}>(Max 10)</span>}
              </h4>
              <button className={styles['close-btn']} onClick={() => setShowBenefitsModal(false)}>×</button>
            </div>
            
            <div className={`${styles['benefits-scrollbar']} ${styles['scrollbar-primary']}`}>
              <div className={styles['benefits-force-overflow']}>
                <div className={`${styles['modal-body']} mx-3 p-0 ${styles['list-benefits']}`}>
                  {benefitsList.map((benefit, index) => (
                    <React.Fragment key={index}>
                      <input
                        type="checkbox"
                        id={`benefits_list_${index}`}
                        className={styles['benefit-checkbox']}
                        value={benefit.benefits}
                        checked={benefits.includes(benefit.benefits)}
                        onChange={() => handleBenefitToggle(benefit.benefits)}
                      />
                      <label htmlFor={`benefits_list_${index}`}>{benefit.benefits}</label>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
            
            <div className={styles['modal-footer']}>
              <button 
                type="button" 
                className={styles['confirm-btn']} 
                onClick={() => setShowBenefitsModal(false)}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* KEY SKILLS POPUP */}
      {showKeySkillsPopup && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['key-skills-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Select key skills <span className={styles['max-indicator']}>(Max 5)</span></h4>
              <button className={styles['close-btn']} onClick={() => setShowKeySkillsPopup(false)}>×</button>
            </div>
            
            <div className={styles['selected-skills']}>
              {keySkills.map((skill, index) => (
                <span key={index} className={styles['selected-skill']}>
                  {skill}
                  <button onClick={() => handleKeySkillToggle(skill)}>×</button>
                </span>
              ))}
            </div>
            
            <div className={styles['search-container']}>
              <input
                type="text"
                className={styles['keyskills-search']}
                placeholder="Search skills"
                onChange={handleKeySkillSearch}
              />
              <span className={styles['search-icon']}>🔍</span>
            </div>
            
            <div className={styles['skills-list-container']}>
              <div className={styles['skills-list']}>
                {(filteredKeySkills.length > 0 ? filteredKeySkills : keySkillsList).map((skill, index) => (
                  <label key={index} className={`${styles['skill-item']} ${keySkills.includes(skill.skill) ? styles.selected : ''}`}>
                    <input
                      type="checkbox"
                      checked={keySkills.includes(skill.skill)}
                      onChange={() => handleKeySkillToggle(skill.skill)}
                    />
                    <span>{skill.skill}</span>
                  </label>
                ))}
              </div>
            </div>
            
            <div className={styles['modal-footer']}>
              <button className={styles['confirm-btn']} onClick={() => setShowKeySkillsPopup(false)}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* EDUCATION QUALIFICATION POPUP */}
      {showEduQualityPopup && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['education-modal']}`}>
            <div className={styles['modal-header']}>
              <h4>Educational Qualification</h4>
              <button className={styles['close-btn']} onClick={() => setShowEduQualityPopup(false)}>×</button>
            </div>
            
            <div className={styles['qualifications-list']}>
              {[
                { value: 'Below 10th', id: 'Below10th' },
                { value: '10th Pass and Above', id: '10thPassandAbove' },
                { value: 'ITI', id: 'ITI' },
                { value: 'Diploma', id: 'Diploma' },
                { value: 'UG', id: 'UG' },
                { value: 'PG', id: 'PG' }
              ].map(qual => (
                <label key={qual.id} className={`${styles['qualification-item']} ${educationQualification.includes(qual.value) ? styles.selected : ''}`}>
                  <input
                    type="checkbox"
                    checked={educationQualification.includes(qual.value)}
                    onChange={() => {
                      handleEducationToggle(qual.value);
                      removeError('education');
                    }}
                  />
                  <span>{qual.value}</span>
                </label>
              ))}
            </div>
            
            <div className={styles['modal-footer']}>
              <button className={styles['confirm-btn']} onClick={() => setShowEduQualityPopup(false)}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* SAVE POPUP */}
      {showSavePopup && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['save-modal']}`}>
            <h5>Do you want to save the job to publish later?</h5>
            <div className={styles['button-group']}>
              <button className={styles['cancel-btn']} onClick={() => setShowSavePopup(false)}>
                No
              </button>
              <button className={styles['confirm-btn']} onClick={saveAsDraft} disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* WHATSAPP ALERT POPUP */}
      {showWhatsAppAlert && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['whatsapp-alert-modal']}`}>
            <p>
              Turning off this option will stop the WhatsApp alert service. You will not receive notifications on WhatsApp for candidate responses.
            </p>
            <h6>Are you sure you want to turn off this option?</h6>
            <div className={styles['button-group']}>
              <button className={styles['secondary-btn']} onClick={() => {
                setWhatsappNoti(false);
                setShowWhatsAppAlert(false);
              }}>
                Yes
              </button>
              <button className={styles['primary-btn']} onClick={() => setShowWhatsAppAlert(false)}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* OTP POPUP */}
      {showOtpPopup && (
        <div className={styles['modal-overlay']}>
          <div className={`${styles['modal-content']} ${styles['otp-modal']}`}>
            {!otpVerified ? (
              <>
                <div className={styles['modal-header']}>
                  <h2>OTP Verification</h2>
                  <button className={styles['close-btn']} onClick={() => setShowOtpPopup(false)}>×</button>
                </div>
                
                <p className={styles['otp-message']}>
                  Please enter the OTP code sent <br />to <span>+91 {otpFor === 'alternate' ? alternateNum : contactNum}</span>
                </p>
                
                <div className={styles['otp-inputs']}>
                  {[0, 1, 2, 3, 4, 5].map(index => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      ref={el => otpInputsRef.current[index] = el}
                      value={otpValues[index]}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    />
                  ))}
                </div>
                
                {showOtpError && <div className={styles['error-message']}>Invalid OTP entered</div>}
                
                <button 
                  className={styles['verify-btn']} 
                  onClick={verifyOtp}
                  disabled={otpLoading}
                >
                  {otpLoading ? 'Verifying...' : 'Verify'}
                </button>
                
                <p className={styles['resend-text']}>
                  Didn't receive an OTP? 
                  {otpTimer > 0 ? (
                    <span className={styles['timer']}>Resend in {otpTimer}s</span>
                  ) : (
                    <button className={styles['resend-btn']} onClick={resendOtp}>
                      Resend
                    </button>
                  )}
                </p>
              </>
            ) : (
              <>
                <h2 className={styles['verified-title']}>Mobile Number Verified</h2>
                <div className={styles['verified-image']}>
                  <img src={indianFlag} alt="Verified" />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PostJob;